export function updateSupervisorStatistics(statistics) {
  return {
    type: 'UPDATE_SupervisorStatistics',
    statistics: statistics
  }
}

export function updateTaskBackLogs(logs) {
  return {
    type: 'UPDATE_TaskBackLogs',
    logs: logs
  }
}

export function updateTaskMessages(messages) {
  return {
    type: 'UPDATE_TaskMessages',
    messages: messages
  }
}

export function updateWorkers(workers) {
  return {
    type: 'UPDATE_Workers',
    workers: workers
  }
}

export function updateReservations(reservations) {
  return {
    type: 'UPDATE_Reservations',
    reservations: reservations
  }
}

export function updateTaskSwitchTimeStamp(timeStamp) {
  return {
    type: 'UPDATE_TimeStamp',
    currentTaskSwitchTimeStamp: timeStamp 
  }
}

export function updateFilterSelection(selectedCategory) {
  return {
    type: 'UPDATE_SelectedCategory',
    selectedCategory: selectedCategory 
  }
}

export function updateTaskQueueCategories(queueCategories) {
  return {
    type: 'UPDATE_TaskQueueCategories',
    queueCategories: queueCategories 
  }
}

export function updateTeamsView(agentDataTable) {
  return {
    type: 'UPDATE_TeamsView',
    agentDataTable: agentDataTable 
  }
}

export function updateFilterQueues(allQueues) {
  return {
    type: 'UPDATE_TeamsQueues',
    allQueues: allQueues
  }
}
